var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { id: "container_completed" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c("v-col", [
                    !_vm.club && _vm.club.length === 0
                      ? _c("h2", [_vm._v("Vielen Dank für Ihre Anmeldung!")])
                      : _c("h2", [
                          _vm._v(
                            "Vielen Dank für Ihre Anmeldung bei " +
                              _vm._s(_vm.club) +
                              "!"
                          ),
                        ]),
                  ]),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _vm.status == "Erfolg"
                    ? _c(
                        "v-col",
                        [
                          _c("h3", { staticClass: "green--text" }, [
                            _vm._v("Die Anmeldung war erfolgreich."),
                          ]),
                          _c("br"),
                          _vm._v(" Ihre Anmeldung ist jetzt "),
                          _c("b", [_vm._v("abgeschlossen")]),
                          _vm._v(
                            ". Sollten Sie noch Fragen haben, können Sie uns gerne per Mail oder direkt telefonisch kontaktieren. "
                          ),
                          _c("br"),
                          _c("br"),
                          _c(
                            "v-col",
                            [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            [
                                              _c(
                                                "v-card-text",
                                                {
                                                  staticClass:
                                                    "text-center d-flex flex-column align-center pb-0",
                                                },
                                                [
                                                  _c("h3", [
                                                    _vm._v(
                                                      "Kennen Sie die VereinsZeit-App?"
                                                    ),
                                                  ]),
                                                  _c("v-img", {
                                                    staticClass: "ma-2",
                                                    attrs: {
                                                      src: require("@/assets/icon_vz.png"),
                                                      alt: "VereinsZeit App",
                                                      width: "120",
                                                      height: "120",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " Mit VereinsZeit haben Sie alle Ihre Mitgliedsinformationen immer dabei."
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    " Sie können Ihre Mitgliedsdaten verwalten, Ihre Mitgliedsbeiträge einsehen und Hallen und Kurse buchen - die Sie direkt aus der App per Paypal oder Klarna bezahlen können!"
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    " Mehr Informationen finden Sie auf unserer Webseite:"
                                                  ),
                                                  _c("br"),
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: "https://vereinszeit-app.de/",
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "vereinszeit-app.de"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("br"),
                                                  _c("br"),
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Laden Sie die App jetzt herunter!"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("br"),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c("v-col", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex flex-column flex-no-wrap align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                                staticStyle: {
                                                                  "min-width":
                                                                    "0",
                                                                  "min-height":
                                                                    "max-content",
                                                                  background:
                                                                    "transparent",
                                                                  "box-shadow":
                                                                    "none",
                                                                },
                                                                attrs: {
                                                                  href: "https://play.google.com/store/apps/details?id=com.vereinszeit",
                                                                  target:
                                                                    "_blank",
                                                                  elevation:
                                                                    "0",
                                                                },
                                                              },
                                                              [
                                                                _c("v-img", {
                                                                  attrs: {
                                                                    src: require("@/assets/google-play-black.png"),
                                                                    alt: "Google Play",
                                                                    width:
                                                                      "175",
                                                                    height:
                                                                      "55",
                                                                    contain: "",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                            !_vm.isMobile()
                                                              ? _c("v-img", {
                                                                  attrs: {
                                                                    src: require("@/assets/qrcode_playstore.png"),
                                                                    alt: "QR Code Google Play",
                                                                    width:
                                                                      "175",
                                                                    height:
                                                                      "175",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ]),
                                                      _c("v-col", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex flex-column flex-no-wrap align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                                staticStyle: {
                                                                  "min-width":
                                                                    "0",
                                                                  "min-height":
                                                                    "max-content",
                                                                  background:
                                                                    "transparent",
                                                                  "box-shadow":
                                                                    "none",
                                                                },
                                                                attrs: {
                                                                  href: "https://apps.apple.com/de/app/vereinszeit/id1593616309",
                                                                  target:
                                                                    "_blank",
                                                                  elevation:
                                                                    "0",
                                                                },
                                                              },
                                                              [
                                                                _c("v-img", {
                                                                  attrs: {
                                                                    src: require("@/assets/app-store-black.png"),
                                                                    alt: "App Store",
                                                                    width:
                                                                      "175",
                                                                    height:
                                                                      "55",
                                                                    contain: "",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                            !_vm.isMobile()
                                                              ? _c("v-img", {
                                                                  attrs: {
                                                                    src: require("@/assets/qrcode_appstore.png"),
                                                                    alt: "QR Code App Store",
                                                                    width:
                                                                      "175",
                                                                    height:
                                                                      "175",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.status == "Fehler"
                    ? _c(
                        "v-col",
                        [
                          _c("h3", { staticClass: "red--text" }, [
                            _vm._v(
                              "Bei der Anmeldung ist ein Fehler aufgetreten."
                            ),
                          ]),
                          _c("br"),
                          _vm._v(" Bei Ihrer Anmeldung ist leider etwas "),
                          _c("b", [_vm._v("schiefgelaufen")]),
                          _vm._v("."),
                          _c("br"),
                          _vm._v(
                            " Bitte kontaktieren Sie unseren Verein direkt, mit angabe des untenstehenden Fehlers."
                          ),
                          _c("br"),
                          _vm._v(" Entschuldigen Sie die Unannehmlichkeiten."),
                          _c("br"),
                          _c("br"),
                          _vm.$te("confirmStatusCodes.code_" + _vm.statusCode)
                            ? _c(
                                "v-card",
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("v-col", [
                                        _c("b", [_vm._v("Meldung:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "confirmStatusCodes.code_" +
                                                  _vm.statusCode
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c("v-col", [
                                        _c("b", [_vm._v("Statuscode:")]),
                                        _vm._v(
                                          " " + _vm._s(_vm.statusCode) + " "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "v-card",
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("v-col", [
                                        _c("b", { staticClass: "red--text" }, [
                                          _vm._v(
                                            "Ein unbekannter Fehler ist aufgetreten."
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }